<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="px-0 px-sm-3">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        body-bg-variant="light"
        border-variant="dark"
        class="main-card"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row>
          <b-col>
            <b-card body-class="p-2" class="shadow-sm" border-variant="white">
              <h5 class="m-0">
                <i class="fas fa-tasks"></i> สถานะฝากเงิน
              </h5>
            </b-card>
          </b-col>
        </b-row>
        <div class="btn-group special mt-2 shadow-sm" role="group">
          <b-button
            type="button"
            variant="outline-primary"
            :class="filter == 'ALL' ? 'font-weight-bold active' : 'font-weight-bold'"
            @click="filter = 'ALL'"
          >
            <i class="fas fa-wallet"></i> ทั้งหมด
          </b-button>
          <b-button
            type="button"
            variant="outline-success"
            :class="filter == '1' ? 'font-weight-bold active' : 'font-weight-bold'"
            @click="filter = '1'"
          >
            <i class="fas fa-folder-plus"></i> ฝาก
          </b-button>
          <b-button
            type="button"
            variant="outline-warning"
            :class="filter == '23' || filter == '23' ? 'font-weight-bold active' : 'font-weight-bold'"
            @click="filter = '23'"
          >
            <i class="fas fa-folder-minus"></i> ถอน
          </b-button>
        </div>
        <b-row class="mt-2" v-if="transactions.length == 0">
          <b-col>
            <b-card body-class="p-2 text-center" class="shadow-sm" border-variant="white">
              <small class="text-secondary">ไม่มีรายการ</small>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="transactions.length > 0">
          <b-col
            cols="12"
            v-for="(item, index) in transactions"
            v-bind:key="index"
            v-show="filter == 'ALL' || filter == item.transferType || (filter == '23' && (item.transferType == 2 || item.transferType == 3))"
            class="mb-2"
          >
            <b-card
              header-class="py-2"
              footer-class="py-2"
              body-class="py-2 card-bg"
              body-text-variant="secondary"
              header-bg-variant="dark"
              header-text-variant="white"
              class="shadow-sm"
            >
              <template #header>
                <b-row>
                  <b-col
                    cols="12"
                    sm="12"
                    md="6"
                    class="text-center text-sm-center text-md-left text-lg-left text-lg-left font-weight-bold py-1"
                  >
                    <b-badge variant="dark" class="mr-1" :style="'background-color: ' + banks[item.bankID-1].color + ';'"><img class="bank-icon" :src="banks[item.bankID-1].logo" /> {{ banks[item.bankID-1].code }}</b-badge>
                    ธนาคาร{{ banks[item.bankID-1].title }}
                  </b-col>
                  <b-col
                    cols="12"
                    sm="12"
                    md="6"
                    class="text-center text-sm-center text-md-right text-lg-right text-lg-right font-weight-bold py-1"
                  >
                    สถานะ:
                    <span v-if="item.status == '2'" class="text-success">
                      <i class="far fa-check-circle"></i> สำเร็จ
                    </span>
                    <span v-if="item.status == '1'" class="text-warning">
                      <i class="far fa-clock"></i> รอดำเนินการ
                    </span>
                    <span v-if="item.status == '3'" class="text-danger">
                      <i class="far fa-times-circle"></i> ยกเลิก
                    </span>
                  </b-col>
                </b-row>
              </template>
              <template #footer>
                <b-row>
                  <b-col cols="12" sm="12" md="4">
                    <small>
                      ชื่อบัญชี:
                      <strong>{{item.accountName}}</strong>
                    </small>
                  </b-col>
                  <b-col cols="12" sm="12" md="4">
                    <small>
                      เลขที่บัญชี:
                      <strong>{{item.accountNo}}</strong>
                    </small>
                  </b-col>
                  <b-col cols="12" sm="12" md="4">
                    <small>
                      ช่องทางฝาก:
                      <strong>{{paymentChannelMethods[item.channel-1] ? paymentChannelMethods[item.channel-1].description : '-'}}</strong>
                      <!-- <strong>{{ paymentMethods[paymentMethods.findIndex(x => x.code === item.paymentMethod)].title }}</strong> -->
                    </small>
                  </b-col>
                </b-row>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  sm="12"
                  md="6"
                  class="text-center text-sm-center text-md-left text-lg-left text-lg-left font-weight-bold pt-1"
                >
                  <b-badge variant="light" class="text-success mr-2" v-if="item.transferType == '1'">
                    <i class="fas fa-folder-plus"></i> ฝากเงิน
                  </b-badge>
                  <b-badge variant="light" class="text-danger mr-2" v-if="item.transferType == '2'">
                    <i class="fas fa-folder-plus"></i> ถอนเงิน
                  </b-badge>
                  <b-badge variant="light" class="text-danger mr-2" v-if="item.transferType == '3'">
                    <i class="fas fa-folder-minus"></i> ถอนเครดิต
                  </b-badge>
                  ฿ {{item.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                </b-col>
                <b-col
                  cols="12"
                  sm="12"
                  md="6"
                  class="text-center text-sm-center text-md-right text-lg-right text-lg-right font-weight-bold py-1"
                >
                  <small>
                    <i class="fas fa-calendar-week"></i>
                    {{formatDate(item.createdDate, "DD/MM/YYYY HH:mm:ss")}}
                  </small>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  name: "Transaction",
  props: ['page'],
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      filter: "ALL",
      transactions: [],
      paymentChannelMethods: [
        {
          value: 1,
          title: "ATM",
          description: "โอนจากตู้กดเงินสด"
        },
        {
          value: 2,
          title: "CDM",
          description: "ฝากผ่านตู้ฝากเงินสด"
        },
        {
          value: 3,
          title: "Counter Cashier",
          description: "ฝากเงินผ่านเคาน์เตอร์ธนาคาร"
        },
        {
          value: 4,
          title: "Internet Banking",
          description: "โอนเงินผ่านหน้าเว็บไซต์"
        },
        {
          value: 5,
          title: "Mobile Banking",
          description: "โอนเงินผ่านแอพมือถือ"
        }
      ],
      banks: [
        {
          bankID: 1,
          code: "BBL",
          title: "กรุงเทพ",
          logo: require('../../assets/images/bank-icon/bbl.svg'),
          color: "#1e4598"
        },
        {
          bankID: 2,
          code: "KBANK",
          title: "กสิกรไทย",
          logo: require('../../assets/images/bank-icon/kbank.svg'),
          color: "#138f2d"
        },
        {
          bankID: 3,
          code: "KTB",
          title: "กรุงไทย",
          logo: require('../../assets/images/bank-icon/ktb.svg'),
          color: "#1ba5e1"
        },
        {
          bankID: 4,
          code: "SCB",
          title: "ไทยพาณิชย์",
          logo: require('../../assets/images/bank-icon/scb.svg'),
          color: "#4e2e7f"
        },
        {
          bankID: 5,
          code: "BAY",
          title: "กรุงศรีอยุธยา",
          logo: require('../../assets/images/bank-icon/bay.svg'),
          color: "#fec43b"
        },
        {
          bankID: 6,
          code: "CIMB",
          title: "ซีไอเอ็มบี",
          logo: require('../../assets/images/bank-icon/cimb.svg'),
          color: "#7e2f36"
        },
        {
          bankID: 7,
          code: "GSB",
          title: "ออมสิน",
          logo: require('../../assets/images/bank-icon/gsb.svg'),
          color: "#eb198d"
        },
        {
          bankID: 8,
          code: "KIATNAKIN",
          title: "เกียรตินาคิน",
          logo: require('../../assets/images/bank-icon/kk.svg'),
          color: "#199cc5"
        },
        {
          bankID: 9,
          code: "LHBANK",
          title: "แลนด์ แอนด์ เฮาส์",
          logo: require('../../assets/images/bank-icon/lhb.svg'),
          color: "#6d6e71"
        },
        {
          bankID: 10,
          code: "STANDARD",
          title: "สแตนดาร์ดชาร์เตอร์ด (ไทย)",
          logo: require('../../assets/images/bank-icon/sc.svg'),
          color: "#0f6ea1"
        },
        {
          bankID: 11,
          code: "THANACHART",
          title: "ธนชาติ",
          logo: require('../../assets/images/bank-icon/tbnk.svg'),
          color: "#fc4f1f"
        },
        {
          bankID: 12,
          code: "TISCO",
          title: "ทิสโก้",
          logo: require('../../assets/images/bank-icon/tisco.svg'),
          color: "#12549f"
        },
        {
          bankID: 13,
          code: "TMB",
          title: "ทหารไทย",
          logo: require('../../assets/images/bank-icon/tmb.svg'),
          color: "#1279be"
        },
        {
          bankID: 14,
          code: "UOB",
          title: "ยูโอบี",
          logo: require('../../assets/images/bank-icon/uob.svg'),
          color: "#0b3979"
        }
      ]
    };
  },
  mounted() {
    this.getTransaction();
  },
  methods: {
    formatDate(datetime, format) {
      return moment(String(datetime)).format(format);
    },
    getTransaction() {
      axios.post(this.getApiUrl + "/cash/getallcashtransfer",
        {
          username: this.getUsername
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        })
        .then(response => {
          this.transactions = response.data.data;
          console.log('get transaction', response);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

.bank-icon {
  width: 8px;
  height: 8px;
  margin-top: -1px;
}

.btn-group.special {
  display: flex;
}

.special .btn {
  flex: 1;
}

.card-bg {
  background-color: #d6d8db;
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.credit-balance {
  background-color: #d4edda !important;
  border-color: #c3e6cb;
  font-size: 30px;
  line-height: 40px;
  height: 48px;

  :focus {
    outline: none;
  }
}

.active {
  background: radial-gradient(
      ellipse farthest-corner at right bottom,
      #fedb37 0%,
      #fdb931 8%,
      #9f7928 30%,
      #8a6e2f 40%,
      transparent 80%
    ),
    radial-gradient(
      ellipse farthest-corner at left top,
      #ffffff 0%,
      #ffffac 8%,
      #d1b464 25%,
      #5d4a1f 62.5%,
      #5d4a1f 100%
    );
  color: #ffffff !important;
  border: goldenrod 1px solid !important;
}
</style>